// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__1sM3o","minWidth":"grid_minWidth__1yG8F"};